import { Controller } from '@hotwired/stimulus'

// data_entities filter (ported verbatim from DataEntities.mdx ## JS).
// Single-select category tag + multi-select sub-filter checkboxes + search,
// composing (AND) to toggle the `hidden` attribute on each entity card.
// Wired in connect() against the spec's data-* hooks (data-cat / data-de-grid /
// data-de-search) rather than Stimulus targets, so the ERB markup matches the
// builder spec.
// Attached to .data-entities via data-controller="data-entities-filter".
export default class extends Controller {
  connect() {
    const root = this.element

    this.tags = Array.from(root.querySelectorAll('.data-entities__tag-btn'))
    this.cards = Array.from(
      root.querySelectorAll('[data-de-grid] .data-entities__card')
    )
    this.input = root.querySelector('input[type="search"]')

    this.category = (
      root.querySelector(
        '.data-entities__tag.is-active .data-entities__tag-btn'
      ) || this.tags[0]
    ).dataset.cat
    this.query = ''

    this.onTagClick = event => {
      this.tags.forEach(t => {
        t.setAttribute('aria-selected', 'false')
        t.closest('.data-entities__tag').classList.remove('is-active')
      })
      const btn = event.currentTarget
      btn.setAttribute('aria-selected', 'true')
      btn.closest('.data-entities__tag').classList.add('is-active')
      this.category = btn.dataset.cat
      this.render()
    }
    this.tags.forEach(btn => btn.addEventListener('click', this.onTagClick))

    this.onChange = event => {
      if (event.target.matches('.data-entities__sub input[type="checkbox"]'))
        this.render()
    }
    root.addEventListener('change', this.onChange)

    this.onInput = () => {
      this.query = this.input.value.trim().toLowerCase()
      this.render()
    }
    this.input.addEventListener('input', this.onInput)

    this.onSubmit = event => event.preventDefault()
    this.form = root.querySelector('[data-de-search]')
    this.form.addEventListener('submit', this.onSubmit)

    this.render()
  }

  disconnect() {
    this.tags.forEach(btn => btn.removeEventListener('click', this.onTagClick))
    this.element.removeEventListener('change', this.onChange)
    this.input.removeEventListener('input', this.onInput)
    this.form.removeEventListener('submit', this.onSubmit)
  }

  activeSubs() {
    return Array.from(
      this.element.querySelectorAll(
        `.data-entities__subfilters[data-for="${this.category}"] input[type="checkbox"]:checked`
      )
    ).map(c => c.dataset.sub)
  }

  render() {
    const subs = this.activeSubs()
    this.cards.forEach(card => {
      const cats = (card.dataset.categories || '').split(',')
      const csub = (card.dataset.subfilters || '').split(',').filter(Boolean)
      const inCat = cats.includes(this.category)
      const inSub = subs.length === 0 || csub.some(s => subs.includes(s))
      const inQ =
        !this.query ||
        (card.dataset.name || '').toLowerCase().includes(this.query)
      card.hidden = !(inCat && inSub && inQ)
    })
  }
}
